document.addEventListener('alpine:init', () => {
  var { removeSectionWrapper } = Alpine.store('utilities');

  Alpine.store('cart', {
    sectionIds: ['cart-data'],

    data: window.global.cart,

    init() {
      window.addEventListener('cartchangesuccess', (event) => {
        this.data = JSON.parse(removeSectionWrapper(event.detail.res.sections['cart-data']));
      });
    }
  });
});
